import { useTranslation } from "@flare/i18n";

import { i18n } from "@/services/locale/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";
import type {
  ChoiceObject,
  PracticeList,
  StepFunnelAnswers,
} from "./step.types";

export type SubPracticeChoicesMap = {
  [k in PracticeList]: ChoiceObject[];
};

const INPUT_NAME = funnelInputsNameMap.subPractice;

export function SubPracticeStep({ answers }: { answers: StepFunnelAnswers }) {
  const { t } = useTranslation();
  const { practice } = answers;
  const choices = getStepChoices({ practice });

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{t("FUNNEL_SUB_PRACTICE_TITLE")}</StepTitle>
          <ChoiceBoxContent name={INPUT_NAME} choices={choices} required />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}

function getStepChoices({
  practice,
}: {
  practice: PracticeList | undefined;
}): ChoiceObject[] {
  if (!practice) {
    return [];
  }

  const choices: SubPracticeChoicesMap = {
    family: [
      {
        label: i18n.t("FUNNEL_FAMILY_SUB_PRACTICE_DIVORCE"),
        value: "divorce",
      },
      {
        label: i18n.t("FUNNEL_FAMILY_SUB_PRACTICE_CHILD_CUSTODY"),
        value: "child-custody",
      },
      {
        label: i18n.t("FUNNEL_FAMILY_SUB_PRACTICE_CHILD_SUPPORT"),
        value: "child-support",
      },
      {
        label: i18n.t("FUNNEL_FAMILY_SUB_PRACTICE_CHILD_ELSE"),
        value: "else",
      },
    ],
    immigration: [
      {
        label: i18n.t("FUNNEL_IMMIGRATION_SUB_PRACTICE_GREEN_CARD"),
        value: "green-card",
      },
      {
        label: i18n.t("FUNNEL_IMMIGRATION_SUB_PRACTICE_CITIZENSHIP"),
        value: "citizenship",
      },
      {
        label: i18n.t("FUNNEL_IMMIGRATION_SUB_PRACTICE_FIANCE_VISA"),
        value: "fiance-visa",
      },
      {
        label: i18n.t("FUNNEL_IMMIGRATION_SUB_PRACTICE_CHILD_ELSE"),
        value: "else",
      },
    ],
  };

  return choices[practice] || [];
}
